// API Configuration for AB Party Frontend
const isDevelopment = process.env.NODE_ENV === 'development';
let apiUrl;
let baseUrl;

if (isDevelopment) {
  // Use local backend when running in development
  apiUrl = 'http://localhost:5000/api';
  baseUrl = 'http://localhost:5000';
} else {
  // In production, use the same domain (cPanel setup serves both frontend and backend)
  apiUrl = '/api';
  baseUrl = '';
}

export const API_BASE_URL = apiUrl;
export const BASE_URL = baseUrl;

// Helper function to get proper image URL
export const getImageUrl = (imagePath) => {
  if (!imagePath) return null;

  let url = String(imagePath).trim();

  // Full URL or blob
  if (/^https?:\/\//i.test(url) || url.startsWith('blob:')) return url;

  // Strip any absolute server path up to 'uploads/'
  const uploadsIdx = url.indexOf('uploads/');
  if (uploadsIdx !== -1) {
    url = url.slice(uploadsIdx); // keep from uploads/... onward
  }

  // Remove leading slashes
  url = url.replace(/^\/+/, '');

  // Remove leading 'api/' if present
  url = url.replace(/^api\/+/, '');

  // Ensure it starts with 'uploads/'
  if (!url.startsWith('uploads/')) {
    url = `uploads/${url}`;
  }

  // Return proper URL based on environment
  if (isDevelopment) {
    return `${baseUrl}/${url}`;
  } else {
    return `/api/${url}`; // served by backend static handler
  }
};

// Debug logging removed for production cleanliness 